








































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'
import { maskMoney } from '@/utils/common'

@Component
export default class FinanceiroTabelaRegrasTeto extends Vue {
  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get regrasTeto() { return this.getRegrasDeCalculoStore.regrasTeto }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get paginacao() { return this.getRegrasDeCalculoStore.paginacaoRegraTeto }

  headers = [
    { text: 'Descrição', value: 'descricaoRegra', sortable: false },
    { text: 'Valor referência', value: 'valorReferencia', sortable: false },
    { text: 'Valor teto', value: 'valorTeto', sortable: false },
    { text: 'Início Vigência', value: 'vigenciaInicio', sortable: false },
    { text: 'Fim Vigência', value: 'vigenciaFim', sortable: false },
    { text: 'Ações', value: 'actions', sortable: false }
  ]

  loadingEditarRegrasAgendaGarantiaMinima = ''
  showModalDelete = false

  deleteRegra(item: any) {
    this.getRegrasDeCalculoStore.setIdForDeleteRegraTeto(item.id)
    this.showModalDelete = true
  }

  fecharModalDelete() {
    this.showModalDelete = false
  }

  async confirmarDelete() {
    const response = await this.getRegrasDeCalculoStore.deleteRegraTeto()

    if (response && response.success !== false) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Regra excluída com sucesso',
        icon: 'done',
        color: '#2E7D32'
      })
      this.getRegrasDeCalculoStore.getRegraTeto(this.paginacao)
      this.fecharModalDelete()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao excluir regra',
        icon: 'warning',
        color: '#D32F2F'
      })
    }
  }

  formatMoneyUtil(value: any) {
    return maskMoney(value)
  }

  displayDateAndHours(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  async editarRegra(item: any) {
    this.loadingEditarRegrasAgendaGarantiaMinima = item.id
    this.getRegrasDeCalculoStore.setItemRegraTeto(item)
    this.getRegrasDeCalculoStore.setMode('EDIT')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeTeto', value: true })
    this.loadingEditarRegrasAgendaGarantiaMinima = ''
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegraTeto(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced(pagination)
    this.loadingRegrasDeCalculo = false
  }

  async created() {
    await this.getRegrasDeCalculoStore.getRegraTeto(this.paginacao)
    await this.getRegrasDeCalculoStore.getValorDeReferenciaEnum()
    await this.getRegrasDeCalculoStore.getValorReferenciaTipos()
  }

  beforeDestroy() {
    this.getRegrasDeCalculoStore.clearRegrasDeCalculo()
    this.getRegrasDeCalculoStore.clearRegraDeCalculo()
    this.getRegrasDeCalculoStore.clearTabelasPreco()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
  }
}
